import React from 'react';
import { useTranslation } from 'react-i18next';
import PageHeaderNav, { TabItem } from '../../components/PageHeaderNav';
import { useUserInfo } from '../../context/UserInfo';
import { routes } from '../../routes';

export const ApprovalRequestNav: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { t } = useTranslation();
  const userInfo = useUserInfo();

  const activeTabs: (TabItem | null)[] = userInfo.isActive
    ? [
        {
          label: t('absences.absenceRequests.pending'),
          route: routes.pendingApprovalRequests.route,
        },
        {
          label: t('absences.absenceRequests.all'),
          route: routes.allApprovalRequests.route,
        },
      ]
    : [];

  return (
    <PageHeaderNav
      tabItems={activeTabs.filter((x): x is TabItem => x !== null)}
    />
  );
};
